import { useCallback } from 'react';

import { useDecoratePositionedMarks } from 'src/components/RichSlate';
import { useDecorateTextInsights } from 'src/lib/slate';

export const useDecorate = (editor, { detectedBrandTerms, positionedMarks }) => {
  const decoratePositionedMarks = useDecoratePositionedMarks({ editor, markup: positionedMarks });
  const decorateTextInsights = useDecorateTextInsights(editor, detectedBrandTerms);

  return useCallback(
    (nodeEntry) => {
      const rangesFromMarks = decoratePositionedMarks(nodeEntry);
      const rangesFromTextInsights = decorateTextInsights(nodeEntry);

      return [...rangesFromMarks, ...rangesFromTextInsights];
    },
    [decoratePositionedMarks, decorateTextInsights]
  );
};
